import { TrendType } from '@cmps/ng-kit';

export function determineTrend(
    currentActual: number | null,
    previousActual: number | null,
): { trendId: TrendType; trendColor: string } {
    if (previousActual === null || currentActual === null) {
        return { trendId: TrendType.UNKNOWN, trendColor: '#000' };
    } else if (currentActual > previousActual) {
        return { trendId: TrendType.UP, trendColor: '#4b8a08' };
    } else if (currentActual < previousActual) {
        return { trendId: TrendType.DOWN, trendColor: '#941000' };
    } else {
        return { trendId: TrendType.NEUTRAL, trendColor: '#000' };
    }
}
